"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RobotModel = void 0;
var RobotModel;
(function (RobotModel) {
    RobotModel["CRX_10IA"] = "crx10ia";
    RobotModel["CRX_25IA"] = "crx25ia";
    RobotModel["M710_IC45M"] = "m710ic45m";
    RobotModel["M20_ID35"] = "m20id35";
    RobotModel["DOOSAN_H2017"] = "doosan_h2017";
    RobotModel["UR3_E"] = "ur3_e";
    RobotModel["UR10_E"] = "ur10_e";
    RobotModel["UR20"] = "ur20";
    RobotModel["M410_IB140H"] = "m410ib140h";
})(RobotModel = exports.RobotModel || (exports.RobotModel = {}));
